import React, { useState } from 'react';

export const OSContext = React.createContext();

export const checkActiveOS = () => {
  const currentActiveOS = window.location.pathname.includes('/sos')
    ? 'sales'
    : window.location.pathname.includes('/mos')
    ? 'marketing'
    : '';
  let activeOS = 'sales';
  if (!currentActiveOS) {
    // do nothing
  } else if (currentActiveOS === 'sales') {
    // do nothing
  } else if (currentActiveOS === 'marketing') {
    activeOS = 'marketing';
  }
  sessionStorage.setItem('os', currentActiveOS);
  return activeOS;
};

export default ({ children }) => {
  const currentActiveOS = checkActiveOS();
  const [activeOS, setActiveOS] = useState(currentActiveOS);
  const defaultContext = {
    activeOS,
    setActiveOS,
  };
  return <OSContext.Provider value={defaultContext}>{children}</OSContext.Provider>;
};
